module.exports = __webpack_public_path__ + "img/654a0df5ce6a4241adceb8ce796b1db7_mergeImage.754761e5.png";